import { createDefaultContext } from "@imi/ui/helpers/createDefaultContext.js";
import { createContext } from "react";

type Context = {
  tracker?: Tracker;
};
type Tracker = {
  identify: (uniqueId: string, eventData?: umami.EventData) => void;
  trackEvent: (eventName: string, eventData?: umami.EventData) => void;
};

export const AnalyticsContext = createContext<Context>(createDefaultContext());
